import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import TableauDashboardList from './components/dashboardlist';
import TableauViz2 from './components/tableauviz';
import UserSettings from './components/userSettings';
import PasswordRecovery from './components/passwordrecovery';
import PasswordRecoveryChange from './components/passwordrecoverychange';
import FirstTimeLogin from './components/firstTimeLogin';
import AddEditEntity from './components/addEditEntities';
//import {UserEditAccountModal} from './components/userEdtitAccount';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/dashboardlist" Component={TableauDashboardList} />  
      <Route path="/dashboard" Component={TableauViz2} />
      <Route path="/settings" Component={UserSettings} />
      <Route path="/passwordrecover" Component={PasswordRecovery} />
      <Route path="/:webuserid" Component={PasswordRecoveryChange} />
      <Route path="/firsttime" Component={FirstTimeLogin} />
      
      <Route path="/czar" Component={AddEditEntity} />
    </Routes>
    
  </BrowserRouter>
);
